import { Box, Button, Flex, Icon } from '@chakra-ui/react';
import { useState } from 'react';
import { MdInfoOutline } from 'react-icons/md';

interface FrozenSizeWarningProps {
  stroke: string;
  gridHeight: number;
  gridWidth: number;
}
const FrozenSizeWarning: React.FC<FrozenSizeWarningProps> = ({
  stroke,
  gridHeight,
  gridWidth,
}) => {
  const [isVisible, setVisibility] = useState(true);

  const fitInGrid = gridHeight >= 200 && gridWidth >= 300;

  return isVisible && fitInGrid ? (
    <Box
      position="absolute"
      right="10px"
      bottom="10px"
      borderRadius="10px"
      padding="10px"
      boxShadow="2xl"
      maxWidth="300px"
      maxHeight="230px"
      background="InfoBackground"
      zIndex={100}
      border={`1px solid ${stroke}`}
    >
      <Flex alignItems="center" justifyContent="center">
        <Icon as={MdInfoOutline} boxSize="25px" color="orange" />
      </Flex>
      <Box fontSize={14} padding="10px" textAlign="justify">
        The sheet cannot be displayed properly due to the small window size.
        Please resize your browser window or adjust frozen rows and columns for
        better visibility.
      </Box>
      <Button
        borderRadius="full"
        width="100%"
        onClick={() => setVisibility(false)}
        fontSize={13}
        textTransform="uppercase"
      >
        Skip for now
      </Button>
    </Box>
  ) : null;
};

export default FrozenSizeWarning;
